import { BoundingBox, CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, Metric, MetricMetadata } from "../services/types";
import { indicatorsEnv, metricsEnv } from "./environment";

import healthyFoodSvg from '../assets/healthy-food.svg';
import populationSvg from '../assets/pop-blue.svg';
import disabledSvg from '../assets/individuals-with-disabilities.svg';
import globeSvg from '../assets/foreign-globe.svg';
import limitedEnglishSvg from '../assets/limitedenglish-blue.svg';
import internetSvg from '../assets/internet.svg';
import vehicleSvg from '../assets/vehicle.svg';
import busSvg from '../assets/bus-icon 1.svg';
import roadConditionsSvg from '../assets/road-conditions.svg';
import retailSvg from '../assets/retail-jobs.svg';
import voterSvg from '../assets/voter-participation.svg';
import libraryAccessSvg from '../assets/library-access.svg';
import trailsSvg from '../assets/trails.svg';
import parksQualitySvg from '../assets/qualityparks.svg';

import houseSvg from '../assets/housing-cost-burden.svg';
import costBurdenSvg from '../assets/cost-burdened.svg';
import selfRatedSvg from '../assets/self-rated-health.svg';
import healthInsuranceSvg from '../assets/health-insurance-icon 1.svg';
import fatalSvg from '../assets/fatal-crash.svg';
import lifeExpectancySvg from '../assets/life-expectancy.svg';
import walkabilityindexSvg from '../assets/walkabilityindex.svg';

import educationAttainSvg from '../assets/educationattainment.svg';
import hsgradSvg from '../assets/highschool-grad.svg';
import studentTestSvg from '../assets/studenttest.svg';
import studentMobilitySvg from '../assets/student-mobility.svg';
import kindergartenSvg from '../assets/kindergarten.svg';

import qualityjobsSvg from '../assets/qualityjobs.svg';
import unemploymentSvg from '../assets/unemployment.svg';
import hhincomeSvg from '../assets/medhhincome.svg';
import homeOwnershipSvg from '../assets/homeownership.svg';
import nonautoSvg from '../assets/nonautojobs.svg';
import povSvg from '../assets/povertyrate.svg';

import trafficSvg from '../assets/traffic.svg';
import treesSvg from '../assets/trees.svg';
import dieselSvg from '../assets/diesel.svg';
import pmSvg from '../assets/PM2.5.svg';
import toxicReleaseSvg from '../assets/toxicrelease.svg';
import ozoneSvg from '../assets/ozone.svg';

import healthyFoodIcon from '../assets/pngs/healthy-food.png';
import populationIcon from '../assets/pngs/pop-blue.png';
import disabledIcon from '../assets/pngs/individuals-with-disabilities.png';
import globeIcon from '../assets/pngs/foreign-globe.png';
import limitedEnglishIcon from '../assets/pngs/limitedenglish-blue.png';
import internetIcon from '../assets/pngs/internet.png';
import vehicleIcon from '../assets/pngs/vehicle.png';
import busIcon from '../assets/pngs/bus-icon 1.png';
import roadConditionsIcon from '../assets/pngs/road-conditions.png';
import retailIcon from '../assets/pngs/retail-jobs.png';
import voterIcon from '../assets/pngs/voter-participation.png';
import libraryAccessIcon from '../assets/pngs/library-access.png';
import trailsIcon from '../assets/pngs/trails.png';
import parksQualityIcon from '../assets/pngs/qualityparks.png';

import houseIcon from '../assets/pngs/housing-cost-burden.png';
import costBurdenIcon from '../assets/pngs/cost-burdened.png';
import selfRatedIcon from '../assets/pngs/self-rated-health.png';
import healthInsuranceIcon from '../assets/pngs/health-insurance-icon 1.png';
import fatalIcon from '../assets/pngs/fatal-crash.png';
import lifeExpectancyIcon from '../assets/pngs/life-expectancy.png';
import walkabilityindexIcon from '../assets/pngs/walkabilityindex.png';

import educationAttainIcon from '../assets/pngs/educationattainment.png';
import hsgradIcon from '../assets/pngs/highschool-grad.png';
import studentTestIcon from '../assets/pngs/studenttest.png';
import studentMobilityIcon from '../assets/pngs/student-mobility.png';
import kindergartenIcon from '../assets/pngs/kindergarten.png';

import qualityjobsIcon from '../assets/pngs/qualityjobs.png';
import unemploymentIcon from '../assets/pngs/unemployment.png';
import hhincomeIcon from '../assets/pngs/medhhincome.png';
import homeOwnershipIcon from '../assets/pngs/homeownership.png';
import nonautoIcon from '../assets/pngs/nonautojobs.png';
import povIcon from '../assets/pngs/povertyrate.png';

import trafficIcon from '../assets/pngs/traffic.png';
import treesIcon from '../assets/pngs/trees.png';
import dieselIcon from '../assets/pngs/diesel.png';
import pmIcon from '../assets/pngs/PM2.5.png';
import toxicReleaseIcon from '../assets/pngs/toxicrelease.png';
import ozoneIcon from '../assets/pngs/ozone.png';


// #region Organization Metric Mapping
const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Lacey
    52:
    [
        {
            name: "Demographics",
            ids: [1130, 1131, 1132, 1133, 1134, 1135, 1147, 1148, 1173, 1182, 1184],
            order: [
                [1133, 1184, 1130],
                [1131, 1132],
            ],
            charts: [
                {
                    name: "race",
                    id: 1134
                },
                {
                    name: "immigration",
                    id: 1182
                }
            ]
        },
        {
            name: "Accessibility",
            ids: [1124, 1137, 1149, 1157, 1158, 1160, 1165, 1166, 1168, 1178, 1179],
            order: [
                [1157, 1124, 1137, 1178, 1166, 1158, 1165, 1149, 1160, 1179],
            ],
            charts: []
        },
        {
            name: "Livability",
            ids: [1128, 1129, 1150, 1151, 1159, 1172, 1181, 1183], // 1146: Percent Low Life Expectancy removed on 8/25
            order: [
                [1129, 1181, 1159, 1128, 1150, 1151],
            ],
            charts: [
                {
                    name: "crime",
                    id: 1183
                },
            ]
        },
        {
            name: "Education",
            ids: [1127, 1161, 1162, 1163, 1164, 1170],
            order: [
                [1127, 1163, 1162, 1161],
                [1164] 
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [1125, 1126, 1138, 1139, 1140, 1167, 1169],
            order: [
                [1167, 1140, 1126, 1125, 1138, 1139],
            ],
            charts: []
        },
        {
            name: "Environment",
            ids: [1141, 1142, 1143, 1144, 1145, 1152, 1171],
            order: [
                [1141, 1152, 1142, 1144, 1145, 1143],
            ],
            charts: []
        }
    ],
    
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    1130: 0,
    1131: 0,
    1132: 0,
    1133: 0,
    1134: 0,
    1135: 0,
    1147: 0,
    1148: 0,
    1182: 0,
    1184: 0,
    1157: 1,
    1160: 1,
    1178: 1,
    1124: 0,
    1137: 0,
    1149: 0,
    1158: 0,
    1165: 0,
    1166: 0,
    1179: 0,
    1139: 1,
    1140: 1,
    1167: 1,
    1125: 0,
    1126: 0,
    1138: 0,
    1127: 2,
    1161: 1,
    1162: 1,
    1163: 1,
    1164: 1,
    1141: 0,
    1145: 0,
    1152: 0,
    1128: 1,
    1146: 1,
    1159: 1,
    1181: 1,
    1129: 0,
    1150: 0,
    1183: 0,
};

// Identify metrics included in the index
export const indexMetricIds: number[] = [1128, 1129, 1150, 1151, 1159, 1181, 1124, 1137, 1149, 1157, 1158, 1160, 1178, 1179, 1126, 1139, 1167, 1140, 1161, 1162, 1163, 1164, 1127, 1141, 1142, 1143, 1144, 1145, 1152];

const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Lacey
    52: {
        1133: populationSvg,  // Population
        1184: populationSvg, // Population (city lod)
        1131: disabledSvg, // Individuals with Disabilities
        1130: globeSvg, // Foreign Born Population
        1132: limitedEnglishSvg, // Limited English
        1124: internetSvg, // Internet Access
        1137: vehicleSvg, // Access to Household Vehicle
        1178: roadConditionsSvg, // Average Road Quality
        1179: parksQualitySvg, // Parks Access
        1157: busSvg, // Transit Accessibility
        1166: retailSvg, // Retail Service Jobs
        1158: voterSvg, // Four Year Average Voter Participation Rate 
        1165: libraryAccessSvg, // Library Access
        1160: trailsSvg, // Pedestrian and Bike Trails
        1149: healthyFoodSvg, // Food Access
        1129: houseSvg, // Median Home Value
        1128: healthInsuranceSvg, // Health Uninsured Rate
        1150: fatalSvg, // Fatal Service Injury Crashes
        1146: lifeExpectancySvg, // Percent Low Life Expectancy
        1181: costBurdenSvg, // Cost-Burdened Households
        1159: selfRatedSvg, // Self Rated Health
        1151: walkabilityindexSvg, // Walkability Index
        1167: qualityjobsSvg, // Quality Jobs Index
        1140: unemploymentSvg, // Unemployment Rate
        1126: hhincomeSvg, // Median Household Income
        1125: homeOwnershipSvg, // Home Ownership Rate
        1138: nonautoSvg, // Non auto Commuters
        1139: povSvg, // Poverty Rate
        1127: educationAttainSvg, // Educational Attainment
        1163: hsgradSvg, // Four Year HS Graduation Rate
        1162: studentTestSvg, // Average Student Test Rate
        1161: studentMobilitySvg, // Average Student Mobility Rate
        1164: kindergartenSvg, // Kindergarten Readiness
        1141: trafficSvg, // Heavy Traffic Roadways
        1152: treesSvg, // Urban Tree Canopy
        1142: dieselSvg, // Diesel Emissions
        1144: pmSvg, // PM 2.5 Concentration
        1145: toxicReleaseSvg, // Toxic Releases from Facilities
        1143: ozoneSvg, // Ozone Concentration
    },
    
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Lacey
    52: {
        1133: populationSvg,  // Population
        1184: populationSvg, // Population (city lod)
        1131: disabledSvg, // Individuals with Disabilities
        1130: globeSvg, // Foreign Born Population
        1132: limitedEnglishSvg, // Limited English
        1124: internetSvg, // Internet Access
        1137: vehicleSvg, // Access to Household Vehicle
        1178: roadConditionsSvg, // Average Road Quality
        1179: parksQualitySvg, // Parks Access
        1157: busSvg, // Transit Accessibility
        1166: retailSvg, // Retail Service Jobs
        1158: voterSvg, // Four Year Average Voter Participation Rate 
        1165: libraryAccessSvg, // Library Access
        1160: trailsSvg, // Pedestrian and Bike Trails
        1149: healthyFoodSvg, // Food Access
        1129: houseSvg, // Median Home Value
        1128: healthInsuranceSvg, // Health Uninsured Rate
        1150: fatalSvg, // Fatal Service Injury Crashes
        1146: lifeExpectancySvg, // Percent Low Life Expectancy
        1181: costBurdenSvg, // Cost-Burdened Households
        1159: selfRatedSvg, // Self Rated Health
        1151: walkabilityindexSvg, // Walkability Index
        1167: qualityjobsSvg, // Quality Jobs Index
        1140: unemploymentSvg, // Unemployment Rate
        1126: hhincomeSvg, // Median Household Income
        1125: homeOwnershipSvg, // Home Ownership Rate
        1138: nonautoSvg, // Non auto Commuters
        1139: povSvg, // Poverty Rate
        1127: educationAttainSvg, // Educational Attainment
        1163: hsgradSvg, // Four Year HS Graduation Rate
        1162: studentTestSvg, // Average Student Test Rate
        1161: studentMobilitySvg, // Average Student Mobility Rate
        1164: kindergartenSvg, // Kindergarten Readiness
        1141: trafficSvg, // Heavy Traffic Roadways
        1152: treesSvg, // Urban Tree Canopy
        1142: dieselSvg, // Diesel Emissions
        1144: pmSvg, // PM 2.5 Concentration
        1145: toxicReleaseSvg, // Toxic Releases from Facilities
        1143: ozoneSvg, // Ozone Concentration
    },
    
};

const pdfIconMap: Record<number, string> =
{
    1133: populationIcon,  // Population
    1184: populationIcon, // Population (city lod)
    1131: disabledIcon, // Individuals with Disabilities
    1130: globeIcon, // Foreign Born Population
    1132: limitedEnglishIcon, // Limited English
    1124: internetIcon, // Internet Access
    1137: vehicleIcon, // Access to Household Vehicle
    1178: roadConditionsIcon, // Average Road Quality
    1179: parksQualityIcon, // Parks Access
    1157: busIcon, // Transit Accessibility
    1166: retailIcon, // Retail Service Jobs
    1158: voterIcon, // Four Year Average Voter Participation Rate 
    1165: libraryAccessIcon, // Library Access
    1160: trailsIcon, // Pedestrian and Bike Trails
    1149: healthyFoodIcon, // Food Access
    1129: houseIcon, // Median Home Value
    1128: healthInsuranceIcon, // Health Uninsured Rate
    1150: fatalIcon, // Fatal Service Injury Crashes
    1146: lifeExpectancyIcon, // Percent Low Life Expectancy
    1181: costBurdenIcon, // Cost-Burdened Households
    1159: selfRatedIcon, // Self Rated Health
    1151: walkabilityindexIcon, // Walkability Index
    1167: qualityjobsIcon, // Quality Jobs Index
    1140: unemploymentIcon, // Unemployment Rate
    1126: hhincomeIcon, // Median Household Income
    1125: homeOwnershipIcon, // Home Ownership Rate
    1138: nonautoIcon, // Non auto Commuters
    1139: povIcon, // Poverty Rate
    1127: educationAttainIcon, // Educational Attainment
    1163: hsgradIcon, // Four Year HS Graduation Rate
    1162: studentTestIcon, // Average Student Test Rate
    1161: studentMobilityIcon, // Average Student Mobility Rate
    1164: kindergartenIcon, // Kindergarten Readiness
    1141: trafficIcon, // Heavy Traffic Roadways
    1152: treesIcon, // Urban Tree Canopy
    1142: dieselIcon, // Diesel Emissions
    1144: pmIcon, // PM 2.5 Concentration
    1145: toxicReleaseIcon, // Toxic Releases from Facilities
    1143: ozoneIcon, // Ozone Concentration
};

// #endregion



// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (name: string) => {

    let ids = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            ids = group.ids;
        }
    }

    return ids;
}

// Store our organization Id where we can access it later
export var orgId: number = 52;
export const setOrgId = (id: number) => {
    orgId = id;
}

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}

// Store our bounding box so we can access it later
export let boundingBox: BoundingBox | null = null;
export const setBoundingBox = (bb: BoundingBox) => {
    boundingBox = bb;
}

// Store our excludeIds so we can access them later
export let excludeIds: string[] | null = null;
export const setExcludeIds = (ids: string[]) => {
    excludeIds = ids;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (id: number) => {
    let svg = "";
    if(svgMap[orgId] != undefined){
        svg = svgMap[orgId][id];
    }
    return svg;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgMap = (id: number) => {
    let svg = "";
    if(pdfSvgMap[orgId] != undefined){
        svg = pdfSvgMap[orgId][id];
    }
    return svg;
}

export const getPDFMetricIcon = (id: number) => pdfIconMap[id];

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (name: string) => {
    let orderIds = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            orderIds = group.order;
        }
    }

    return orderIds;
}

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = ( group: string, key: string) => {
    let id = -1;

    if(organizationMetrics[orgId] != undefined){
        const g = organizationMetrics[orgId].find((x: { name: string; }) => x.name === group);
        if(g != undefined){
            
            if(g.charts != undefined){

                const chart = g.charts.find((x: { name: string; }) => x.name === key);
                if(chart != undefined){
                    id = chart.id;
                }
            }
        }
    }

    return id;
}

export const categorizeData = (indicators: DisaggregatedMetric[]) => {

    const categories: { [key: string]: number[] } = {
        Livability: getMetricGroupIds("Livability"),
        Education: getMetricGroupIds("Education"),
        Economy: getMetricGroupIds("Economy"), 
        Environment: getMetricGroupIds("Environment"),
        Accessibility: getMetricGroupIds("Accessibility"),
        Demographics: getMetricGroupIds("Demographics"),
    };

    // Initialize the categorizedData object dynamically with empty arrays for each category
    const categorizedData: Record<string, Metric[]> = Object.keys(categories).reduce((acc, category) => {
        acc[category] = [];
        return acc;
    }, {} as Record<string, Metric[]>);

    // Categorize the indicators dynamically
    indicators.forEach((item) => {
        Object.keys(categories).forEach((category) => {
            if (categories[category].includes(item.id)) {
                categorizedData[category].push(item);
            }
        });
    });

    return categorizedData;
};

export const fetchMetricCategories = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetriccategories?orgId=${orgId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetch PercentileDist - get percentile distribution information by org and category
export const fetchPercentileDist = async (orgId: number, category: string) => {
    if (!orgId || !category) {
        console.log('No orgId or category provided to fetch metric percentile distributions');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentiledist?orgId=${orgId}&category=${category}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchPercentileById - get percentile distribution information by metric id
export const fetchPercentileById = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch metric percentile data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentilebymetric?metricId=${metricId}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching percentile data:', error);
    }
};

// fetchDistributionData - get distribution data by metric id and selected area
export const fetchDistributionData = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdistributiondata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchIndicatorBinCount - get indicator data and bin count by metric id and selected area
export const fetchIndicatorBinCount = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbincounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

export const calculateGeoPrefix = (geoDetails: GeoDetails[]): string => {
    // Flatten the geoIds array
    const geoIds = geoDetails.flatMap(geo => geo.ids);

    // Helper function to get the first two digits of a geoId
    const getGeoPrefix = (geoId: string): string => geoId.substring(0, 2);

    // Count occurrences of each prefix
    const prefixCount: Record<string, number> = {};
    geoIds.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        prefixCount[prefix] = (prefixCount[prefix] || 0) + 1;
    });

    // Find the prefix with the highest count
    return Object.entries(prefixCount).reduce((prev, curr) => 
        curr[1] > prev[1] ? curr : prev, ['', 0]
    )[0];
};

export const fetchMetricsData = async (tabs: string[], geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    const geoEncoding = 'delta';
    const indicatorsUrl = `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getallindicatorsv2`;

    const lowerTabs = tabs.map(tab => tab.toLowerCase());

    const fetchPromises = lowerTabs.map(category =>
        fetch(indicatorsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                geoDetails,
                orgId: 52,
                dashboardView: category,
                geoEncoding,
                geoTag,
                environment: indicatorsEnv,
                allowDefault: true
            }),
        }).then(res => {
            if (!res.ok) throw new Error(`Failed to fetch data for ${category}`);
            return res.json();
        })
    );

    const results = await Promise.all(fetchPromises);
    return results.flat(); // returns DisaggregatedMetric[]
};


// getMissingMetrics - utility function to check for missing metrics on a given dashboard panel
export const getMissingMetrics = (
    tab: string,
    categorizedData: Metric[],
    indicators: DisaggregatedMetric[] | null
  ): string => {
    if (!indicators) return '';
  
    const missingMetrics = indicators?.filter(metric => 
        metric.category?.toLowerCase() === tab.toLowerCase() && 
        !categorizedData.some(data => data.id === metric.id)
    ) || [];    
  
    return missingMetrics.map(metric => metric.name).join(", ");
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (category: string, categorizedData: CategorizedData) => {
    const orders = getMetricGroupOrderIds(category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};

// Helper function to get and sort metrics by category - Used in PDF metrics display
export const getSortedMetricsPDF = (category: string, categorizedData : {
    category: string;
    metrics: DisaggregatedMetric[];
}[]): DisaggregatedMetric[] => {
    const metrics = categorizedData.find(data => data.category === category)?.metrics || [];
    const orders = getMetricGroupOrderIds(category);
    return orders.flatMap((order: number[]) =>
      metrics
        .filter(metric => order.includes(metric.id))
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};
  
// Helper function to get the index metric data
export const getIndexMetricData = (
    category: string, 
    metadata: MetricMetadata[] | null, 
    disaggregatedData: DisaggregatedMetric[]
): { indexMetricId: number; indexMetricData: DisaggregatedMetric | null } => {
    
    const indexMetricId = metadata?.find(
        (metric) => 
            metric.metric_source_type === "index" && 
            metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;

    const indexMetricData = disaggregatedData.find(metric => metric.id === indexMetricId) || null;

    return { indexMetricId, indexMetricData };
};

// Helper function to get the index metric data - Formatted for PDF (MetricModal) use.
export const getIndexMetricDataPDF = (category: string, metadata: MetricMetadata[] | null, disaggregatedData: DisaggregatedMetric[]): DisaggregatedMetric | null => {
    const indexMetricId = metadata?.find(
        (metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;
    return disaggregatedData.find(metric => metric.id === Number(indexMetricId)) || null;
};
